import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { eq } from 'ember-truth-helpers'
import { SortDirection } from 'teacher-ui-client/components/data-operations/table/sort-definition'

interface Signature {
  Element: HTMLSpanElement
  Args: {
    columnName: string
    sortCol?: string
    sortDir?: SortDirection
  }
}

export const ColumnSortIcon: TOC<Signature> = <template>
  <PhosphorIcon
    ...attributes
    @icon={{if
      (eq @sortCol @columnName)
      (if (eq @sortDir SortDirection.Asc) "phosphor-caret-up-fill" "phosphor-caret-down-fill")
      "phosphor-caret-up-down-fill"
    }}
  />
</template>
